import isBrowser from './isBrowser';

declare global {
  interface Window {
    __IS_HAPPO_RUN: boolean;
  }
}

const isHappoRun = isBrowser() && window.__IS_HAPPO_RUN;

export default function isTestRender() {
  return isHappoRun;
}
